import { Typography } from '@customink/pigment-react';
import { useDecision } from '~/contexts/OptimizelyContext';

interface CurrentVariationProps {
    feature: string;
}

export function CurrentVariation({ feature }: CurrentVariationProps) {
    const [decision] = useDecision(feature);

    return <Typography variant="bodyShort1">{decision.variationKey}</Typography>;
}
